<template>
  <view class="place" :style="{ height: 44 + navHeight + 'px' }">
    <view class="weixnbar" :style="{ paddingTop: (navHeight - 2) + 'px',paddingBottom: '12px',backgroundColor: bg || '#fff' }">
      <view class="logo-img">
		<image :src="$common.serviceImg('logo.png')"></image>
		<view style="flex: 1">
			<slot></slot>
		</view>
      </view>
    </view>
  </view>
</template>

<script>
export default {
  props: {
    bg: {
		type: String,
		default: ''
	}
  },
  data() {
    return {
      navHeight: 0,
    };
  },
  mounted() {
    // wx.getSystemInfo({
    //   success: (res) => {
    //     this.navHeight = res.statusBarHeight + 6;
    //   },
    // });
	let res = uni.getWindowInfo()
	this.navHeight = res.statusBarHeight + 6;
  },
};
</script>

<style lang="scss" scoped scoped>
.place {
  // height: 200rpx;
}
.weixnbar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 666;
  width: 100%;
  padding: 0 212rpx 0 24rpx;
  display: flex;
  align-items: center;
  background-color: #fff;

  .logo-img {
    @include flex;
	width: 100%;
	image {
		width: 150rpx;
		height: 88rpx;
	}
  }
}
</style>
